import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';

const Section = ({ title, links }) => (
    <div style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 28, fontWeight: 400, marginBottom: 12 }}>{title}</h2>
        {links.map(({ label, to }) => (
            <div key={to} style={{ marginBottom: 6 }}>
                <Link to={to}>{label}</Link>
            </div>
        ))}
    </div>
);

function AdminDashboard() {
    return (
        <div style={{ padding: '40px 60px' }}>
            <Row gutter={80}>
                <Col span={12}>
                    <Section title="Finanzen:" links={[
                        { label: 'Alle Auszahlungen', to: '/payouts' },
                        { label: 'Auszahlung Züchter', to: '/payout/list' },
                        { label: 'Aufträge an Dritte', to: '/third-party-orders' },
                        { label: 'VA-Extern', to: '/va-extern' },
                        { label: 'Finanzübersicht nach Standort', to: '/proj-calculation' },
                        { label: 'Standortprofilauftrag', to: '/fp-report' },
                    ]} />
                    <Section title="Evaluation:" links={[
                        { label: 'Projekt-Evaluation', to: '/project-review' },
                        { label: 'FG-Evaluation', to: '/fg-review-list' },
                        { label: 'FG-Budget nach Züchter', to: '/fg_budget_years/' },
                    ]} />
                    <Section title="Austausch ZSL:" links={[
                        { label: 'ZSL-Antrag', to: '/zsl-antrag' },
                        { label: 'ZSL-Bericht', to: '/zsl' },
                        { label: 'Saatgutfonds', to: '/zsl-summary' },
                    ]} />
                </Col>
                <Col span={12}>
                    <Section title="Einstellungen:" links={[
                        { label: 'Projekt-Einstellungen', to: '/project-settings' },
                        { label: 'Benutzerverwaltung', to: '/user-management' },
                        { label: 'Startseite editieren', to: '/start-page' },
                        { label: 'EZ-Sorten', to: '/sorten' },
                        { label: 'Projekttyp konvertieren', to: '/project-convert' },
                    ]} />
                    <Section title="Sonstiges:" links={[
                        { label: 'Projektfinanzierung', to: '/project-funding' },
                        { label: 'Kulturartausblick', to: '/crop-forecast' },
                    ]} />
                </Col>
            </Row>
        </div>
    );
}

export default AdminDashboard;
